
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "SelectableContainercomponent2395678784",
      {"classes":{"root":"SelectableContainercomponent2395678784__root","wrapper":"SelectableContainercomponent2395678784__wrapper"},"vars":{},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  